import FileModal from './FileModal'

export default FileModal
